import {Component, Inject} from '@angular/core';
import {RegistrationIdImport} from '../../../../shared/interface/registration-id-import';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommissionRedirectionImport} from '../../../../shared/interface/commission-redirection-import';

export interface ImportResultDialogData {
  import: CommissionRedirectionImport;
}

@Component({
  selector: 'app-import-result-dialog',
  templateUrl: './import-result-dialog.component.html',
  styleUrls: ['./import-result-dialog.component.scss']
})
export class ImportResultDialogComponent {

  import: CommissionRedirectionImport;

  constructor(
    public dialogRef: MatDialogRef<ImportResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImportResultDialogData,
  ) {
    this.import = data.import;
  }

}
